import { baseColors } from './base-colors';

export function conditionViolationColor(id: string): string {
  switch (id) {
    case 'HIGH_AVG_SOC':
      return baseColors[0];
    case 'REST_SOC':
      return baseColors[1];
    case 'EXCESSIVE_CYCLING':
      return baseColors[2];
    case 'LARGE_DOD':
      return baseColors[4];
    case 'THROUGHPUT':
      return baseColors[5];
    case 'TEMPERATURE_SPIKE':
      return baseColors[8];
    case 'HIGH_VOLTAGE':
      return baseColors[3];
    case 'COOLDOWN_INTERRUPTED':
      return baseColors[6];
    case 'C_RATE_HIGH':
      return baseColors[7];
    case 'C_RATE_LOW':
      return baseColors[7];
    case 'CURRENT_HIGH':
      return baseColors[9];
    case 'CURRENT_LOW':
      return baseColors[9];
    case 'EFC_HIGH':
      return baseColors[2];
    case 'POWER_HIGH':
      return baseColors[11];
    case 'POWER_LOW':
      return baseColors[11];
    case 'SOC_HIGH_AVG':
      return baseColors[0];
    case 'SOC_HIGH':
      return baseColors[0];
    case 'SOC_RESTING_HIGH':
      return baseColors[0];
    case 'SOC_LOW':
      return baseColors[1];
    case 'TEMPERATURE_HIGH':
      return baseColors[8];
    case 'TEMPERATURE_HIGH_AVG':
      return baseColors[8];
    case 'TEMPERATURE_LOW':
      return baseColors[9];
    case 'VOLTAGE_HIGH':
      return baseColors[3];
    case 'VOLTAGE_LOW':
      return baseColors[3];
    case 'NO_DATA':
      return baseColors[10];
    case 'UNKNOWN':
    default:
      return baseColors[16];
  }
}
